export const GenerateToken = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.99935 2.66797C3.05268 2.66797 0.666016 5.05464 0.666016 8.0013C0.666016 10.948 3.05268 13.3346 5.99935 13.3346C8.94602 13.3346 11.3327 10.948 11.3327 8.0013C11.3327 5.05464 8.94602 2.66797 5.99935 2.66797ZM7.99935 7.0013H6.66602V10.3346H5.33268V7.0013H3.99935V6.0013H7.99935V7.0013ZM13.4993 2.5013L15.3327 3.33464L13.4993 4.16797L12.666 6.0013L11.8327 4.16797L9.99935 3.33464L11.8327 2.5013L12.666 0.667969L13.4993 2.5013ZM13.4993 11.8346L15.3327 12.668L13.4993 13.5013L12.666 15.3346L11.8327 13.5013L9.99935 12.668L11.8327 11.8346L12.666 10.0013L13.4993 11.8346Z"
      fill="#175CE5"
    />
  </svg>
);
